import MUIDataTable from 'mui-datatables'
import { columnsOrderTable, optionsOrderTable } from './EnumOrder'

const OrdersTable = ({ type, orders, canViewCheckbox = false, page = 0, setPage }) => {
  const columns = columnsOrderTable(canViewCheckbox)
  const options = {
    ...optionsOrderTable,
    page,
    onTableChange: (action, tableState) => {
      if (!setPage) return
      if (action === 'changePage' || action === 'changeRowsPerPage') {
        setPage(tableState.page)
      }
    }
  }
  return (
    <div className='pt-4'>
      <div>
        <MUIDataTable title={type == 'user' ? 'User Orders' : 'All Orders'} data={orders} options={options} columns={columns} />
      </div>
    </div>
  )
}

export default OrdersTable
